// extracted by mini-css-extract-plugin
export default {"container":"UserDetailsItem_container__OjlyF","title":"UserDetailsItem_title__UO1L4"};